export default __webpack_public_path__ + "static/media/ok1.ae72356f.jpg";